import React, { createContext, FC, useContext, ReactNode } from 'react';
import { WebGivingUIConfiguration } from '../webgiving-generated';

const initialConfig: WebGivingUIConfiguration = {
	AccountCreationText: '',
	ThankYouText: '',
	HideAccount: false,
	HideACH: false,
	HideI18n: false,
	ReturnButtonUrl: '',
	ReturnButtonText: '',
	HideDonorPortalGivingLinks: false,
	HideKioskGivingLinks: false,
	PaymentScreenText: '',
	HideRecurring: false,
	SkipGivePage: false,
	SuccessBackButtonRedirectUrl: '',
	HideApplePay: false,
	HideGooglePay: false,
	HideSplitGiving: false,
	AttemptSkipGivePage: false
};

export const UiConfigurationContext = createContext<WebGivingUIConfiguration>(initialConfig);

export const UiConfigurationContextProvider: FC<{ config: WebGivingUIConfiguration }> = ({
	config,
	children,
}) => <UiConfigurationContext.Provider value={config}>{children}</UiConfigurationContext.Provider>;

export function useUiConfiguration() {
	return useContext(UiConfigurationContext);
}

export const UiConfiguration: FC<{ children: (config: WebGivingUIConfiguration) => ReactNode }> = ({
	children,
}) => {
	const config = useUiConfiguration();
	return <>{children(config)}</>;
};
